export default __webpack_public_path__ + "static/media/education.ea51ab91.less";